// extracted by mini-css-extract-plugin
export default {"page":"studyProgress_page__A8OBf","stateMessage":"studyProgress_stateMessage__4kpYz","error":"studyProgress_error__rl+LQ","quizBtn":"studyProgress_quizBtn__35M5v"};